<template>
  <div class="max-w-7xl py-6 px-4 sm:px-6 lg:px-8 mx-auto font-thin">
    <slot />
  </div>
</template>
